import { clientFetch } from "@pax/telemetry/client";
import {
  adminClient,
  anonymousClient,
  deviceAuthorizationClient,
  inferAdditionalFields,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/** The web Worker forwards same-origin auth requests to the Product API. */
export const authClient = createAuthClient({
  fetchOptions: { customFetchImpl: clientFetch },
  plugins: [
    anonymousClient(),
    adminClient(),
    deviceAuthorizationClient(),
    // The API's own user fields the web reads, typed here because the web can't import its config.
    inferAdditionalFields({
      user: {
        deletionPurgeAfter: { type: "date", required: false, input: false },
        admittedAt: { type: "date", required: false, input: false },
      },
      session: { checkedAt: { type: "date", required: false, input: false } },
    }),
  ],
});
